export default function getRenamedPanels(title: string) {
  switch (title) {
    case 'General Information':
      return 'Details'
    case 'Party Type':
      return 'Parties'
    case 'Decisioning':
      return 'TC/CO Certificate Decisions'
    default:
      return title
  }
}
